import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { SideNavHeaderViewModel } from './side-nav-header-view-model';
import { BaseComponent } from '../../../../../models/base/base-component';

@Component({
  selector: 'app-side-nav-header',
  standalone: false,
  templateUrl: './side-nav-header.component.html',
  styleUrl: './side-nav-header.component.scss',
  providers: [SideNavHeaderViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavHeaderComponent extends BaseComponent {
  constructor(public viewModel: SideNavHeaderViewModel) {
    super();
  }

  @Output() toggleCollapsed = new EventEmitter<void>(true);
}
